import crypto from '../utils/crypto'
import store from '../store/index'
const LS = {
    set: function(obj) {
        localStorage.setItem("cookie_local", crypto.encrypt(obj, true))
            //console.log('setando cookie local', obj);
        if (obj.session.aluno) {
            //console.log('setando cookie base', obj);
            store.dispatch('upsert_session', crypto.encrypt(obj.session, true))
        }
    },

    get: function() {
        if (localStorage.getItem("cookie_local") != null) {
            //console.log('pegando cookie local', crypto.decrypt(localStorage.getItem("cookie_local"), true));
            return crypto.decrypt(localStorage.getItem("cookie_local"), true);
        } else return { session: {}, shared: {} }
    }
}

export default LS;